import { IScheduleSectionFormValues } from '@src/features/shift-post-v2/steps/shift-details-step/components/schedule-section/schedule-section.types'
import {
  updateDays,
  updateSingleDayShifts,
} from 'ui/components/Admin/Shifts/ShiftEditDuplicate/utils'
import { TDay, TSingleDayShift } from 'ui/components/Admin/Shifts/ShiftEditDuplicate/utils/types'
import { DATE_FORMAT_STRING } from 'helpers/constants/constants'
import { FormikProps } from 'formik'
import { getFinalDay } from '@src/helpers/timeAndDateHelpers'
import { format } from 'date-fns'

const getUpdatedDays = (
  value: string,
  isHourStart: boolean,
  vDays: TDay[],
  vIndividualDays: TDay[],
  vSingleDayShifts: TSingleDayShift[]
) => {
  const days = updateDays(vDays, (day) => {
    const { day_start, hour_start, hour_end } = day
    const day_end = getFinalDay(
      day_start,
      isHourStart ? value : hour_start,
      isHourStart ? hour_end : value
    )
    const date_end = format(day_end, DATE_FORMAT_STRING.MM_dd_yyyy)
    return {
      ...(isHourStart ? { hour_start: value } : { hour_end: value }),
      day_end,
      date_end,
    }
  })

  const individualDays = updateDays(vIndividualDays, (day) => {
    const { day_start, hour_start, hour_end } = day
    const day_end = getFinalDay(
      day_start,
      isHourStart ? value : hour_start,
      isHourStart ? hour_end : value
    )
    const date_end = format(day_end, DATE_FORMAT_STRING.MM_dd_yyyy)
    return {
      ...(isHourStart ? { hour_start: value } : { hour_end: value }),
      day_end,
      date_end,
    }
  })

  const singleDayShifts = updateSingleDayShifts(
    vSingleDayShifts,
    isHourStart ? 'hour_start' : 'hour_end',
    value
  )

  return { days, individualDays, singleDayShifts }
}

export const handleHourChange = (
  value: string,
  isHourStart: boolean,
  formik: FormikProps<IScheduleSectionFormValues>
) => {
  const { setFieldValue, values } = formik

  const fieldName = isHourStart ? 'hour_start' : 'hour_end'

  setFieldValue(fieldName, value)

  const { days, singleDayShifts } = getUpdatedDays(
    value,
    isHourStart,
    values.days,
    [],
    values.single_day_shifts ?? []
  )

  setFieldValue('days', days)
  setFieldValue('single_day_shifts', singleDayShifts)
}
